import React, { useEffect, useState } from 'react'
import MainLayout from '../layouts/MainLayout'
import { useDispatch, useSelector } from 'react-redux'
import { getAllPlans, getDemoRequestData } from '../redux/actions/dashBoardActions'
import moment from 'moment'
import BreadCrums from '../components/BreadCrums'
import Loader from '../components/Loader'
import { Api, BaseUrl } from '../config/apiEndPoints'
import { callApi } from '../config/apiCall'
import { toast } from 'react-toastify'
import RegisterFromDemo from '../components/RegisterFromDemo'
import ViewRequestDetails from '../components/ViewRequestDetails'
import Pagination from '../components/Pagination'
import { getServiceType } from '../redux/actions/otherActions'
import NoData from '../components/NoData'

function DemoRequest() {
    const dispatch = useDispatch()
    const [searchText, setSearchText] = useState("")
    const [updatedStatus, setUpdatedStatus] = useState({ demo_status: "", disable: false })
    const [modalData, setModalData] = useState({ isOpen: false, data: "" })
    const allRequest = useSelector((state) => state.commenData.demoRequestsData)
    const isLoading = useSelector((state) => state.commenData.loading)
    const details = JSON.parse(sessionStorage.getItem("userDetails")) || {}
    const [denoStats, setdenoStats] = useState()
    const [filters, setFilters] = useState({
        limit: 10,
        page: 1,
        deliver: "",
        demo_status: "",
        sort: "",
        currentPage: 1,
    })

    useEffect(() => {
        dispatch(getAllPlans())
        fetchStats()
        dispatch(getServiceType())
    }, [])
    useEffect(() => {
        dispatch(getDemoRequestData(filters))
    }, [filters])

    const fetchStats = async () => {
        try {
            const response = await callApi(Api.DEMOSTATS, "GET", "", details?.token)
            if (response.authenticated && response.valid) {
                setdenoStats(response.data || {})
            }

        } catch (error) {
            //console.log(error);
        }
    }

    const changeFilter = (value, key) => {
        setFilters((prev) => ({
            ...prev,
            [key]: value
        }))
    }
    const updataStatues = async (e, data, type) => {
        try {
            const payload = {
                id: data?.id,
                [type]: e.target.value
            }
            const response = await callApi(Api.UPDATEDEMOSTATUS + `/${data?.id}`, "PUT", payload, details?.token)
            // //console.log("response", response);
            if (response.valid || response.authenticated) {
                toast.success(response.message)
                setUpdatedStatus((prev) => ({
                    ...prev,
                    [data?.id]: {
                        [type]: response?.data?.[type] || "",
                        disable: true  // Or your desired logic for enabling/disabling
                    }
                }))
                dispatch(getDemoRequestData(filters))
                fetchStats()
            }

        } catch (error) {
            //console.log(error);
            toast.error(error.response.data.message || error.message || "Server error")
        }
    }
    const onClose = () => {
        setModalData((prev) => ({
            ...prev,
            isOpen: false
        }))
    }
    const tableHeadings = [
        "Company Name",
        "Domain Name",
        "Company Size",
        "User Name",
        "Email",
        "Contact Number",
        "Service Type",
        "Demo Status",
        // "Config",
        "Meeting Time"
    ];

    const handlePageChange = (page) => {
        // Call your API here to fetch data for the new page
        setFilters(prev => ({
            ...prev,
            currentPage: page,
            page: page
        }));
    };
    const sortOptions = [
        { title: "Recently Added", value: "recent_added" },
        { title: "Descending", value: "descending" },
        { title: "Ascending", value: "ascending" },
        { title: "Last Month", value: "last_month" },
        { title: "Last 7 Days", value: "last_7_days" },
    ];

    return (
        <React.Fragment>
            <MainLayout>
                <div className="page-wrapper">
                    {
                        isLoading ?
                            <Loader /> :
                            <div className="content">
                                <BreadCrums
                                    title={" Demo Request"}
                                    data={[
                                        { path: "/superadmin/", title: "Superadmin" },
                                        { path: "#", title: " Demo Request" },

                                    ]}
                                />
                                <div className="row">
                                    {/* <!-- Total Companies --> */}
                                    <div className="col-lg-3 col-md-6 d-flex">
                                        <div className="card flex-fill">
                                            <div className="card-body d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center overflow-hidden">
                                                    <span className="avatar avatar-lg flex-shrink-0" style={{ background: "#FF2D55" }}>
                                                        <i className="ti ti-message-circle fs-24"></i>
                                                    </span>
                                                    <div className="ms-2 overflow-hidden">
                                                        <p className="fs-12 fw-medium mb-1 text-truncate">Total Request</p>
                                                        <h4>{denoStats?.total || 0}</h4>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 d-flex">
                                        <div className="card flex-fill">
                                            <div className="card-body d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center overflow-hidden">
                                                    <span className="avatar avatar-lg flex-shrink-0" style={{ background: "#047EFF" }}>
                                                        <i className="ti ti-building fs-24"></i>
                                                    </span>
                                                    <div className="ms-2 overflow-hidden">
                                                        <p className="fs-12 fw-medium mb-1 text-truncate"> Demo Done</p>
                                                        <h4>{denoStats?.done || 0}</h4>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 d-flex">
                                        <div className="card flex-fill">
                                            <div className="card-body d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center overflow-hidden">
                                                    <span className="avatar avatar-lg flex-shrink-0" style={{ background: "#5856D6" }}>
                                                        <i className="ti ti-settings fs-24"></i>
                                                    </span>
                                                    <div className="ms-2 overflow-hidden">
                                                        <p className="fs-12 fw-medium mb-1 text-truncate">Pending</p>
                                                        <h4>{denoStats?.pending || 0}</h4>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 d-flex">
                                        <div className="card flex-fill">
                                            <div className="card-body d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center overflow-hidden">
                                                    <span className="avatar avatar-lg flex-shrink-0" style={{ background: "#34C759" }}>
                                                        <i className="ti ti-truck fs-24"></i>
                                                    </span>
                                                    <div className="ms-2 overflow-hidden">
                                                        <p className="fs-12 fw-medium mb-1 text-truncate">Scheduled</p>
                                                        <h4>{denoStats?.scheduled || 0}</h4>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    {
                                        allRequest?.data?.length == 0 ? <NoData /> : <>
                                            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                                <h5> Requested Companies List</h5>
                                                {/* filters  */}
                                                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                                    <div className="dropdown me-3">
                                                        <select value={filters?.demo_status} onChange={(e) => {
                                                            changeFilter(e.target.value, "demo_status")
                                                        }} className='select border py-2 px-2 rounded'>
                                                            <option value={""}> Select Status</ option>
                                                            {
                                                                ["Pending", "Scheduled", "Done", "Not Connected"]?.map((item, i) => {
                                                                    return (
                                                                        <option key={i} value={item}> {item}</ option>
                                                                    )
                                                                })

                                                            }
                                                        </select>
                                                    </div>

                                                    <div className="dropdown ">
                                                        <select value={filters?.sort} onChange={(e) => {
                                                            changeFilter(e.target.value, "sort")
                                                        }} className='select border py-2 px-2 rounded'>
                                                            <option value={""}> Sort</ option>
                                                            {
                                                                sortOptions?.map((item, i) => {
                                                                    return (
                                                                        <option key={i} value={item?.value}> {item.title}</ option>
                                                                    )
                                                                })

                                                            }
                                                        </select>

                                                    </div>
                                                    {
                                                        (filters.sort || filters?.demo_status) &&
                                                        <div className="dropdown ml-1">
                                                            <button onClick={() => {
                                                                setFilters((prev) => ({
                                                                    ...prev,
                                                                    deliver: "",
                                                                    demo_status: "",
                                                                    sort: "",
                                                                }))
                                                            }} className='btn btn-secondary py-1' > Clear</button>
                                                        </div>
                                                    }


                                                </div>
                                            </div>
                                            <div className="row align-items-center px-4">
                                                <div className="col-sm-12 col-md-6">
                                                    <div className="dataTables_length" >
                                                        <label>
                                                            Row per page
                                                            <select value={filters?.limit} onChange={(e) => {
                                                                changeFilter(e.target.value, "limit")
                                                            }} className="form-select form-select-sm">
                                                                <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select>
                                                            Entries
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6">
                                                    <div className="dataTables_filter m-0 text-end">
                                                        <label>
                                                            <input type="search"
                                                                className="form-control form-control-sm"
                                                                placeholder="Search"
                                                                value={searchText}
                                                                onChange={(e) => {
                                                                    setSearchText(e.target.value)
                                                                }}
                                                            />
                                                        </label></div>
                                                </div>
                                            </div>
                                            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                                <div className="card-body sv-card-body p-0">
                                                    <div className="custom-datatable-filter table-responsive">

                                                        <table className="table datatable">
                                                            <thead className="thead-light">
                                                                <tr>
                                                                    <th>Sr. No.</th>
                                                                    {
                                                                        tableHeadings?.map((tableHead, index) => {
                                                                            return (
                                                                                <th key={index}>{tableHead}</th>
                                                                            )
                                                                        })
                                                                    }
                                                                    <th></th>
                                                                </tr>

                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    allRequest?.data?.filter((item) => {
                                                                        if (searchText) {
                                                                            return item.company_name.toLowerCase().includes(searchText.toLowerCase()) ||
                                                                                item.company_domain.toLowerCase().includes(searchText.toLowerCase()) ||
                                                                                item.email.toLowerCase().includes(searchText.toLowerCase())
                                                                        }
                                                                        return item
                                                                    })?.map((item, index) => {
                                                                        const validSelection = Array.isArray(item?.selection)
                                                                            ? item.selection
                                                                            : JSON.parse(item?.selection || "[]");
                                                                        // //console.log(item?.selection ,validSelection);
                                                                        const isdemoStatus = updatedStatus[item?.id]?.demo_status == "Done" || item.demo_status == "Done"

                                                                        return (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}</td>
                                                                                <td>
                                                                                    <div className="d-flex align-items-center file-name-icon">
                                                                                        <div className="ms-2">
                                                                                            <h6 className="fw-medium"><a href="#">{item?.company_name || "NA"}</a></h6>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td>{item?.company_domain || "NA"}</td>
                                                                                <td>{item?.company_size || "NA"}</td>
                                                                                <td>{item?.name || "NA"}</td>
                                                                                <td>{item?.email || "NA"}</td>
                                                                                <td>{item?.phone_no || "NA"}</td>
                                                                                <td>
                                                                                    {
                                                                                        item?.services?.map((item, index) => item.name).join("/")
                                                                                    }
                                                                                </td>
                                                                                <td>
                                                                                    <div>
                                                                                        {
                                                                                            isdemoStatus ?
                                                                                                <div className='demo-status done d-flex justify-content-center '>Done</div> :
                                                                                                <>
                                                                                                    <select
                                                                                                        value={updatedStatus[item?.id]?.demo_status || item.demo_status}
                                                                                                        disabled={isdemoStatus}
                                                                                                        onChange={(e) => {
                                                                                                            updataStatues(e, item, "demo_status")
                                                                                                        }}
                                                                                                        className={`demo-status  
                                                                                                        ${item.demo_status == "Not Connected" ? "not-connected"
                                                                                                                : updatedStatus[item?.id]?.demo_status || item.demo_status} `}>
                                                                                                        <option value={"Pending"}>Pending</option>
                                                                                                        <option value={"Scheduled"}>Scheduled</option>
                                                                                                        <option value={"Not Connected"}>Not Connected</option>
                                                                                                        <option value={"Done"}>Done</option>
                                                                                                    </select>
                                                                                                </>

                                                                                        }
                                                                                    </div>

                                                                                </td>

                                                                                <td>
                                                                                    {item?.demo_date ? moment(item?.demo_date).format("DD/MMM/YYYY") + "," : "NA"} {item?.demo_time || ""}
                                                                                </td>
                                                                                <td>
                                                                                    <div className="action-icon d-inline-flex">
                                                                                        <a href="#" className="me-2"
                                                                                            onClick={() => {
                                                                                                setModalData((prev) => ({
                                                                                                    ...prev,
                                                                                                    data: item,
                                                                                                    isOpen: true,
                                                                                                    type: "viewDetails",
                                                                                                    onClose: onClose
                                                                                                }))
                                                                                            }}
                                                                                            title='View Details'>
                                                                                            <i className="ti ti-eye"></i>
                                                                                        </a>

                                                                                        <a href={
                                                                                            isdemoStatus
                                                                                                ? "#" : item?.meeting_link} className="me-2" target={isdemoStatus ? "" : '_blank'} title='join meeting' >
                                                                                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                <path d="M1.6332 6.19005H8.92986V10.7501H1.6332M1.6332 6.19005L4.66653 3.13672H10.8332C11.0765 3.16215 11.3036 3.27041 11.4766 3.44336C11.6495 3.61631 11.7578 3.84345 11.7832 4.08672V6.27505M1.6332 6.19005V12.8401C1.62958 12.9664 1.65159 13.0922 1.69788 13.2098C1.74417 13.3275 1.81379 13.4345 1.90256 13.5245C1.99132 13.6145 2.09738 13.6856 2.21436 13.7336C2.33133 13.7815 2.4568 13.8052 2.58319 13.8034H10.8332C11.0785 13.7774 11.3073 13.6673 11.4805 13.4916C11.6537 13.316 11.7607 13.0857 11.7832 12.8401V10.6517M13.6832 4.67005C14.2265 4.23672 14.6332 4.59339 14.6332 5.05005V11.8901C14.6332 12.4667 14.2265 12.7034 13.6832 12.2701L8.92986 8.47005L13.6832 4.67005Z" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            </svg>
                                                                                            {/* <i className={`ti ti-device-tv ${isdemoStatus ? "disable-Color" : ""} `} style={{ transform: "rotate(180deg)" }}></i> */}
                                                                                        </a>

                                                                                        <a href="#" className="me-2"
                                                                                            onClick={() => {
                                                                                                // //console.log(item);
                                                                                                if (item?.is_registered) {
                                                                                                    toast.warning("Company Is Already Registered !")
                                                                                                    return
                                                                                                }

                                                                                                if (isdemoStatus) {
                                                                                                    setModalData((prev) => ({
                                                                                                        ...prev,
                                                                                                        data: item,
                                                                                                        isOpen: true,
                                                                                                        type: "register",
                                                                                                        onClose: onClose
                                                                                                    }))
                                                                                                }
                                                                                            }}
                                                                                            title='Register' >
                                                                                            {
                                                                                                item?.is_registered ? <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                    <g opacity="0.3">
                                                                                                        <path d="M1.33301 14.0001C1.33295 12.9737 1.6291 11.969 2.1859 11.1067C2.74271 10.2444 3.53652 9.56112 4.47207 9.13881C5.40762 8.7165 6.44517 8.57314 7.46018 8.72592C8.4752 8.8787 9.42456 9.32114 10.1943 10.0001" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                        <path d="M6.66634 8.66667C8.50729 8.66667 9.99967 7.17428 9.99967 5.33333C9.99967 3.49238 8.50729 2 6.66634 2C4.82539 2 3.33301 3.49238 3.33301 5.33333C3.33301 7.17428 4.82539 8.66667 6.66634 8.66667Z" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                        <path d="M10.667 12.6668L12.0003 14.0002L14.667 11.3335" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                    </g>
                                                                                                </svg>
                                                                                                    : <i className={`ti ti-user-edit ${isdemoStatus ? "" : "disable-Color"}`}></i>

                                                                                            }
                                                                                        </a>
                                                                                        {/* <a href="#" className="me-2" title='Edit' ><i className="ti ti-edit"></i></a> */}
                                                                                        {/* <a href="javascript:void(0);" ><i className="ti ti-trash"></i></a> */}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>

                                                        </table>

                                                    </div>
                                                </div>

                                            </div>
                                            <Pagination pagination={allRequest?.pagination} onPageChange={handlePageChange} />
                                        </>
                                    }
                                </div>

                            </div>
                    }
                </div>
            </MainLayout>
            {
                modalData.type == "viewDetails" ?
                    <ViewRequestDetails handleData={modalData} /> :
                    <RegisterFromDemo filters={filters} handleData={modalData} />
            }
        </React.Fragment>
    )
}

export default DemoRequest
